import { render, staticRenderFns } from "./UiTab.vue?vue&type=template&id=41826a0e"
import script from "./UiTab.vue?vue&type=script&lang=js"
export * from "./UiTab.vue?vue&type=script&lang=js"
import style0 from "./UiTab.vue?vue&type=style&index=0&id=41826a0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports